export const HG_EMAIL = 'honeyhunter@honeyguideapps.com';



// WEBPACK FOOTER //
// ./src/constants/email.js